import { h, Component } from 'preact';
import style from './index.less'

export default (props)=>{
    if(!props.viewBox){
        throw new Error(`viewBox must be provided`)
    }

    return (
        <svg 
            class={`${style.faIcon} ${props.class}`}
            aria-hidden="true" 
            data-prefix="fa" 
            data-icon="check-circle" 
            role="img" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox={props.viewBox}
            style={{
                display: 'none',
                ...Object(props.style)
            }}
            data-fa-i2svg="">
                {props.children}
        </svg>
    )
}


// WEBPACK FOOTER //
// ./components/elements/FontAwesome/BaseIcon.js